import React, { SFC } from "react";
import withForm, { PropsType as WithFormProps } from "../../hoc/withForm";
import withContentWrap, { PropsType as WithContentWrapProps } from "../../hoc/withContentWrap";
import withVerticalSpacing, { PropsType as WithVerticalSpacingProps } from "../../hoc/withVerticalSpacing";
import Form from "../Form";
import Title from "../Title";
import "./style.scss";

type PropsType = WithVerticalSpacingProps &
    HTMLProps<HTMLDivElement> &
    WithContentWrapProps &
    WithFormProps & {
        text?: string;
        title?: string;
    };

const Contact = (props): SFC => {
    return (
        <div className="Contact">
            <div className="Contact__content">
                <div className="Contact__content-wrap">
                    <Title level={2} underline>
                        {props.title}
                    </Title>
                    <div className="Contact__text" dangerouslySetInnerHTML={{ __html: props.text }} />
                </div>
            </div>
            <div className="Contact__form">
                <div className="Contact__form-wrap">
                    <Title level={2}>Stuur een bericht</Title>
                    <Form form={props.form} />
                </div>
            </div>
        </div>
    );
};

export default withVerticalSpacing(withContentWrap(withForm(Contact)));
